import { GenericObject } from "../@types";

export function encodeAttributesUrl(attrs: GenericObject<string>): string {
  const filtered = Object.fromEntries(
    Object.entries(attrs).filter(([, v]) => v !== "" && v != null)
  );
  const json = JSON.stringify(filtered);
  try {
    return window
      .btoa(json)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  } catch {
    return "";
  }
}

export function decodeAttributesUrl(
  attrsUrlValue: string
): GenericObject<string> {
  try {
    const padded =
      attrsUrlValue + "=".repeat((4 - (attrsUrlValue.length % 4)) % 4);
    const json = window.atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return {};
  }
}
